import styled from "styled-components";
import { LOGO_LG } from "@assets";
import { Form as AntForm } from "antd";
import { BackOutlined } from '@assets';

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: linear-gradient(
    180deg,
    rgba(74, 14, 68, 1) 15%,
    rgba(30, 23, 47, 1) 60%
  );
  padding: 0px 29px;
`;

export const Logo = styled.img.attrs({
  alt: "logo",
  src: LOGO_LG,
})`
  width: 180px;
  height: auto;
  object-fit: contain;
  padding-top: 35px;
`;

export const Form = styled(AntForm)`
  margin-top: 50px;
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-label {
    text-align: center;
  }

  .ant-form-item-label label {
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }

  .ant-input-affix-wrapper {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 10px;

    input {
      text-align: center;
    }
  }

  .ant-btn-primary {
    margin-top: 40px;
    width: 170px;
    height: 52px;
    border-radius: 26px !important;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 32px;
`;

export const BackIcon = styled(BackOutlined)`
  font-size: 24px;
  color: #fff;
  cursor: pointer;
`;